import { useQuizContext } from "@/pages/quiz/context";
import { ISectionResult } from "@/pages/quiz/base/components/progressHeaderV1/common";

interface IProps {
  currentSection: ISectionResult;
}

const CompleteLabel = ({ currentSection }: IProps) => {
  const { selectedQuestionIdx } = useQuizContext();

  const answeredIdxInSection = selectedQuestionIdx - currentSection.startIdx;

  return (
    <>
      <div className="w-[1px] bg-purple10 flex-0" />
      <div>
        {answeredIdxInSection + 1}/{currentSection.count}
      </div>
    </>
  );
};

export { CompleteLabel };
